__turbopack_context__.v({
  "button": "CTAButton-module-scss-module__Y7WaxG__button",
  "gray": "CTAButton-module-scss-module__Y7WaxG__gray",
  "icon": "CTAButton-module-scss-module__Y7WaxG__icon",
  "text": "CTAButton-module-scss-module__Y7WaxG__text",
  "white": "CTAButton-module-scss-module__Y7WaxG__white",
});
